export const CLIENT_ID = "qOasgwL0Zjtpth3xOaWeEZtSSaHgGTXT";
export const CLIENT_SECRET = "F2Xkb0sYwJJ38AhvcTPAejEPaA5AxVXk";
export const CLIENT_CREDENTIALS = "client_credentials";
export const GROUP_ID = 20124;
export const FAREID = 4;

export const MENU = {
  FAVORITES: { URL: "/favorites", LABEL: "my_favs" },
  NOTIFICATIONS: { URL: "/notifications", LABEL: "notifications" },
  NEXT_TRAVEL: { URL: "/next-travel", LABEL: "next_travel" },
  CLAIMS: { URL: "/claims", LABEL: "claims" },
  WALLET: { URL: "/wallet", LABEL: "carnet" },
  MOUTEBE: { URL: "/moutebe", LABEL: "moutebe" },
  PROFILE: { URL: "/profile", LABEL: "profile" },
  CONTACT: { URL: "/", LABEL: "virtual_office" },
  STUDENT_YOUNG_PROFILE_CONFIRM_FORM: { URL: "/student-profile-confirm", LABEL: "student_profile_confirm" }
};